import { reactive } from 'vue'

// «Only this one, this and the following, or all of them?» — asked when a
// repeated event is changed, moved or cancelled. One question for the whole
// application, drawn by ScopeDialog inside the editor host, so a drag in the
// week view and the Save of the editor ask it the same way.

const state = reactive({ open: false, action: 'edit', following: true, resolve: null })

export function useScopeChoice() {
  /** @returns {Promise<'this'|'following'|'all'|null>} null = cancelled */
  function ask({ action = 'edit', following = true } = {}) {
    state.resolve?.(null)
    return new Promise((resolve) => {
      Object.assign(state, { open: true, action, following, resolve })
    })
  }
  function answer(value) {
    const resolve = state.resolve
    Object.assign(state, { open: false, resolve: null })
    resolve?.(value)
  }
  return { state, ask, answer }
}
